import { Badge } from "@/components/ui/badge";
import { cn } from "@/components/utils/utils";
import { useI18n } from "@/hooks/useI18n";
import { formatPlatformFeeRate } from "@/lib/payments/utils/payment-method";

/**
 * Aliquota di un'agenzia o di un indipendente, in una pillola sola: numero in grassetto,
 * separatore sottile, qualifica. Lo standard e' grigio e quieto, quella contrattata prende
 * il colore primario: in una lista lunga le eccezioni devono saltare all'occhio.
 * Padding fissato su tutti i breakpoint (il Badge base lo stringe su mobile) e niente a
 * capo, cosi' la colonna resta allineata.
 */
export function PlatformFeeRateBadge({ rate, isCustom }: { rate: number; isCustom: boolean }) {
  const { t } = useI18n();

  return (
    <Badge
      variant="outline"
      className={cn(
        "gap-1.5 px-2.5 md:px-2.5 py-0.5 whitespace-nowrap",
        isCustom
          ? "bg-primary/10 text-primary border-primary/25"
          : "bg-gray-50 text-gray-600 border-gray-200"
      )}
    >
      <span className="font-semibold tabular-nums">{formatPlatformFeeRate(rate)}</span>
      <span aria-hidden className="h-3 w-px bg-current opacity-30" />
      <span className="font-normal">
        {isCustom ? t("dashboard.overview.agencies.rateCustom") : t("dashboard.overview.agencies.rateDefault")}
      </span>
    </Badge>
  );
}

/** Errori della RPC admin_set_platform_fee_rate tradotti; il resto cade sul generico. */
export const PLATFORM_FEE_SET_ERRORS = {
  note_required: "dashboard.overview.agencies.errors.noteRequired",
  invalid_rate: "dashboard.overview.agencies.errors.invalidRate",
  invalid_owner_role: "dashboard.overview.agencies.errors.invalidOwner",
  forbidden: "dashboard.overview.agencies.errors.forbidden",
} as const;
